import { render, staticRenderFns } from "./RegistrationNumbers.vue?vue&type=template&id=f42abf44&scoped=true&"
import script from "./RegistrationNumbers.vue?vue&type=script&lang=js&"
export * from "./RegistrationNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42abf44",
  null
  
)

export default component.exports